import TablePage from 'src/pages/TablePage';
import PropTypes from 'prop-types';
import TableHeader from 'src/components/ui/TableHeader';
import { useLoaderData, useLocation, useNavigate } from 'react-router';
import TablePagination from 'src/components/ui/TablePagination';
import { FilterPopoverProvider } from 'src/components/ui/FilterPopover';
import { getTablePageCrumbs } from 'src/utils/helpers/breadcrumbs';

const TablePageRoute = ({ type, Component, crumbs }) => {
	const { items, pagination, statuses, objectionTypes } = useLoaderData();
	const navigate = useNavigate();
	const location = useLocation();

	if (!type) return console.error('No type specified!');

	const resolvedCrumbs =
		crumbs ?? getTablePageCrumbs(location.pathname, location.search);

	const changeParam = (param, value) => {
		const params = new URLSearchParams(location.search);
		params.set(param, value);
		navigate(`?${params.toString()}`);
	};

	return (
		<FilterPopoverProvider
			dataSignature={`${location.search}|${items
				.map((item) => item?.id)
				.join(',')}|${pagination?.totalCount ?? ''}`}
		>			<TablePage
				tableHeader={<TableHeader crumbs={resolvedCrumbs} />}
				defaultTable={
					<Component
						data={items}
						statuses={statuses}
						objectionTypes={objectionTypes}
					/>
				}
			/>

			<TablePagination
				count={
					pagination
						? pagination.totalPages
						: items.pagination.totalPages
				}
				perPage={
					pagination ? pagination.perPage : items.pagination.perPage
				}
				page={
					pagination
						? pagination.currentPage
						: items.pagination.currentPage
				}
				perPageOptions={[10, 15, 25, 50]}
				onChangePage={(page) => changeParam('page', page + 1)}
				onChangePerPage={(perPage) => changeParam('limit', perPage)}
			/>
		</FilterPopoverProvider>
	);
};

TablePageRoute.propTypes = {
	Component: PropTypes.func,
	crumbs: PropTypes.object,
	type: PropTypes.string,
};

export default TablePageRoute;
